/* eslint-disable import/no-unresolved */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'

import AuthContainer from './containers/AuthContainer/AuthContainer';
import App from './containers/App/App';
import './index.scss';

const DiscApp = () =>
  <AuthContainer useStatus appBase='/usis/advice/checkout'>
    <App />
  </AuthContainer>;

ReactDOM.render(
  <DiscApp />,
  document.getElementById('root')
);
